import React, { useEffect } from 'react';
import { List, Radio } from 'antd';
import { useTranslations } from 'next-intl';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';

import { IUniversitySort } from 'modules/universities';

interface IProps {
  sortUniversity?: IUniversitySort[];
}

const FilterSection: React.FC<IProps> = ({ sortUniversity = [] }) => {
  const t = useTranslations();

  const yearOptions = sortUniversity.map(item => ({
    label: item.year,
    value: item.year
  }));

  const languageSet = new Set<string>();
  const studySet = new Set<string>();

  sortUniversity.forEach(item => {
    item.languages.forEach(lang => languageSet.add(lang));
    item.studies.forEach(study => studySet.add(study));
  });

  const languageOptions = Array.from(languageSet).map(lang => ({
    label: lang,
    value: lang
  }));

  const typeOptions = Array.from(studySet).map(study => ({
    label: study,
    value: study
  }));

  const [query, setQuery] = useQueryParams({
    year: NumberParam,
    language: StringParam,
    study: StringParam
  });

  useEffect(() => {
    const isQueryEmpty = query.year === undefined || query.language === undefined || query.study === undefined;

    if (isQueryEmpty && yearOptions.length && languageOptions.length && typeOptions.length) {
      setQuery(
        {
          year: query.year ?? yearOptions[0]?.value,
          language: query.language ?? languageOptions[0]?.value,
          study: query.study ?? typeOptions[0]?.value
        },
        'replace'
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, yearOptions, languageOptions, typeOptions]);

  return (
    <div className="space-y-4 rounded-xl bg-white p-3 shadow-sm">
      <div>
        <h1 className="text-sm text-gray-400">{t('yil')}</h1>
        <Radio.Group
          value={query.year}
          onChange={e => setQuery({ ...query, year: e.target.value })}
          className="!w-full !font-normal"
        >
          <List
            dataSource={yearOptions}
            renderItem={item => (
              <List.Item>
                <Radio value={item.value} className="!space-x-2 hover:!border-green-500">
                  {item.label}
                </Radio>
              </List.Item>
            )}
          />
        </Radio.Group>
      </div>

      <div>
        <h1 className="text-sm text-gray-400"> {t('TalimTili')}</h1>
        <Radio.Group
          value={query.language}
          onChange={e => setQuery({ ...query, language: e.target.value })}
          className="!w-full !font-normal"
        >
          <List
            dataSource={languageOptions}
            renderItem={item => (
              <List.Item>
                <Radio value={item.value} className="!space-x-2 hover:!border-green-500">
                  {item.label}
                </Radio>
              </List.Item>
            )}
          />
        </Radio.Group>
      </div>

      <div>
        <h1 className="text-sm text-gray-400"> {t('TalimShakli')}</h1>
        <Radio.Group
          value={query.study}
          onChange={e => setQuery({ ...query, study: e.target.value })}
          className="!w-full !font-normal"
        >
          <List
            dataSource={typeOptions}
            renderItem={item => (
              <List.Item>
                <Radio value={item.value} className="!space-x-2 hover:!border-green-500">
                  {item.label}
                </Radio>
              </List.Item>
            )}
          />
        </Radio.Group>
      </div>
    </div>
  );
};

export default FilterSection;
